import styled, { css } from 'styled-components';

export const MessagesListContainer = styled.div`
  width: 100%;

  .ant-list-item {
    background: transparent !important;
  }
`;

export const MessagesListContent = styled.div<{ isMyMessage: boolean }>`
  padding: 8px;
  margin: 4px 0;
  max-width: 90%;
  background: ${({ theme }) => theme.colors.background};
  border: 1px solid ${({ theme }) => theme.colors.border};
  border-radius: ${({ theme }) => theme.shapes.borderRadius};
  position: relative;

  ${({ isMyMessage, theme }) =>
    isMyMessage
      ? css`
          margin-left: auto;
          padding-right: 12px;
          border-right: 2px solid ${theme.colors.primary};
        `
      : css`
          padding-left: 12px;
          border-left: 2px solid ${theme.colors.primary};
        `}

  .list-item-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 0.8rem;

    .list-item-created-by {
      color: ${({ theme }) => theme.colors.primary};
    }

    .list-item-create-at {
      margin-left: 8px;
      color: ${({ theme }) => theme.colors.text1};
    }
  }

  .list-item-note {
    font-size: 0.9rem;
    color: ${({ theme }) => theme.colors.text};
    white-space: pre-wrap;
    word-break: break-word;
  }
`;
